import * as React from 'react';
import { LoaderCircle } from 'lucide-react';
import { cn } from '../lib/cn.js';

/**
 * The one busy indicator. Screens do not invent their own: a pending mutation, a
 * loading table and a saving form all show this.
 */
export function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <LoaderCircle
      data-slot="spinner"
      role="status"
      aria-label="Caricamento"
      className={cn('size-4 animate-spin text-muted', className)}
      {...props}
    />
  );
}
